import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { Box, Skeleton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import Image from 'next/image';
import StyledCardContent from './CardContent.styled';
// import { calculateSlideCardColor } from '../../../util/offerColorCalculator';
import fetchImgData from '../../../util/base64Generator';

const { publicRuntimeConfig } = getConfig();

const EirOfferCardHeader = ({
  preTitle,
  title,
  sash,
  style,
  loading,
  offerSelected,
  headerImage = [],
  switchTheme = false,
  isMobile = false,
  isTv = false,
  cardHovered = false,
  tvMobileViewImg,
  isAddon,
  // slideNumber,
  setHeaderImgLoaded,
  headerImgDescription,
}) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [base64Data, setBase64Data] = useState('');
  const [base64Error, setBase64error] = useState(false);
  const [dataFetched, setdataFetched] = useState(false);

  const getBase64ImgData = async () => {
    const { data } = await fetchImgData(
      `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${headerImage[0]}.base64`
    );
    if (data) {
      setBase64Data(data);
      setdataFetched(true);
      setHeaderImgLoaded('true');
    } else {
      setHeaderImgLoaded('true');
      setdataFetched(true);
      setBase64error(true);
    }
  };

  useEffect(() => {
    if (headerImage.length > 0 && !loading) {
      getBase64ImgData();
    } else if (headerImage.length === 0 && !loading) {
      setdataFetched(true);
    }
  }, [headerImage[0], loading]);

  return (
    <StyledCardContent
      sx={{
        ...(headerImage[0] ? [style.containerWithImage] : style.container),
        ...{ padding: '0rem !important' },
        ...(loading && {
          backgroundColor: theme.palette.primary.contrastText,
          borderRadius: '0.7rem 0.7rem 0rem 0rem',
        }),
      }}
    >
      {/* head title */}
      {dataFetched ? (
        <>
          {headerImage[0] ? (
            <Box style={style.offerCardImgHeader}>
              <Image
                src={
                  isTv && sm
                    ? tvMobileViewImg
                    : `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${headerImage[0]}`
                }
                style={{
                  objectFit: 'cover',
                  objectPosition: cardHovered || offerSelected ? 'bottom center' : 'top center',
                }}
                alt={headerImgDescription && headerImgDescription.length && headerImgDescription[0]}
                placeholder={base64Error ? 'empty' : 'blur'}
                layout='fill'
                blurDataURL={!base64Error && `${base64Data}`}
              />
            </Box>
          ) : (
            <Box
              sx={[
                style?.titleContainer,
                {
                  ...(offerSelected === false &&
                    (switchTheme === false
                      ? { backgroundColor: theme?.palette.primary.offerMain }
                      : { backgroundColor: theme?.palette.primary.OfferSelected })),
                  ...(offerSelected === true &&
                    (switchTheme === false
                      ? { backgroundColor: theme?.palette.primary.OfferSelected }
                      : { backgroundColor: theme?.palette.primary.offerMain })),
                  ...(isMobile && offerSelected === true && switchTheme === true
                    ? { backgroundColor: theme?.palette.primary.simoSelected }
                    : ''),
                },
              ]}
            >
              {preTitle && !headerImage[0] && (
                <Typography variant='h5' sx={style?.preTitle}>
                  {preTitle}
                </Typography>
              )}
              {title && !headerImage[0] && (
                <Typography variant='h2' sx={style?.title}>
                  {title}
                </Typography>
              )}
            </Box>
          )}

          {/* contract tag */}
          {sash?.length > 0 && (
            <Box
              sx={{
                ...style?.contractTag,
                backgroundColor: theme.palette.primary.contrastText,
                ...((isTv || isAddon) && {
                  ...style?.contractTag,
                  backgroundColor: theme.palette.primary.textColor3,
                }),
              }}
            >
              <Typography
                variant='body1'
                sx={{
                  ...style?.contractTag?.contractText,
                  ...((isTv || isAddon) && { color: theme.palette.primary.contrastText }),
                  // ...(isMobile && {
                  //   ...style.mobileContractText,
                  // }),
                }}
                // className='swiper-no-swiping'
              >
                <span dangerouslySetInnerHTML={{ __html: sash }} />
              </Typography>
            </Box>
          )}
        </>
      ) : (
        <Skeleton height={40} width='100%' sx={{ marginX: 'auto', mt: '8rem' }} />
      )}
    </StyledCardContent>
  );
};

export default EirOfferCardHeader;
